import * as angular from "angular";
import {IController, IQService, IScope} from "angular";
import {CommissionStatusType} from "../../types/commission-status.type";
import {FulfillmentSubTypeType} from "../../../fulfillment/types/fulfillment-sub-type.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {ThreePLServiceActionsService} from "../../../threePL/angular/services/threepl-service-actions.service";

export class CommissionsTableRowCtrl implements IController {

  commissionId: string;
  isSelected: any;
  onSelect: Function;
  onDelete: Function;
  onMarkAsPaid: Function;
  onConsolidate: Function;
  onPay: Function;
  onEditPrice: Function;
  onRemoveConsolidate: Function;
  onReject: Function;
  onRestore: Function;
  onSelectRow: Function;

  public CommissionStatusType: typeof CommissionStatusType = CommissionStatusType;
  public commission: any;
  public canCopyServiceId: boolean;
  public expenseTooltipVisible: boolean;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;
  private servicesRef: any;

  constructor(private IAMPermissions, private bringozLoaderService: BringozLoaderService, private $commission,
              private $scope: IScope, private deliveriesDialogService: DeliveriesDialogService, private $delivery,
              private threePLService: ThreePLServiceActionsService, private commonsDialogService: CommonsDialogService, private $q: IQService) {
    this.servicesRef = this.$delivery();
  }

  $onInit() {
    if (this.commissionId) {
      this.$commission(this.commissionId).$bindCtrlToId(this.$scope, this, 'commission', 'commissionId');
    }
  }

  $onChanges(changes) {
    if (changes.commissionId && !changes.commissionId.isFirstChange()) {
      this.$onInit();
    }
  }

  onViewService(dispatchType: FulfillmentSubTypeType) {
    if (dispatchType === this.fulfillmentSubTypeType.ThirdParty) {
      this.bringozLoaderService.on();
      this.$q.when(this.threePLService.getService(this.commission.serviceId))
        .then((service) => {
            this.commonsDialogService.attemptInfoDialog(service, this.fulfillmentSubTypeType.ThirdParty);
          }
        )
        .finally(() => {
          this.bringozLoaderService.off();
        })
    } else {
      this.bringozLoaderService.on();
      this.servicesRef.$asyncValues([this.commission.serviceId])
        .then((services) => {
            this.deliveriesDialogService.serviceInfo(services[0]);
          }
        )
        .finally(() => {
          this.bringozLoaderService.off();
        })
    }
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('commissionsTableRow', {
    require: {
      commissionsTableCtrl: '^commissionsTable'
    },
    bindings: {
      commissionId: '<',
      isSelected: '<?',
      onSelect: '&',
      onSelectRow: '&',
      onDelete: '&',
      onMarkAsPaid: '&',
      onPay: '&',
      onEditPrice: '&',
      onConsolidate: '&',
      onRemoveConsolidate: '&',
      onReject: '&',
      onRestore: '&'
    },
    template: require('./commissions-table-row.html').default,
    controller: CommissionsTableRowCtrl
  });
